import React from 'react'
import { Box, Typography } from '@mui/material'

interface InfoRowProps {
  icon?: React.ReactNode
  label: string
  value: React.ReactNode
}

const InfoRow = ({ icon, label, value }: InfoRowProps) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      py: 1.5,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {icon}
      <Typography
        sx={{
          fontSize: '13px',
          fontWeight: 500,
          color: 'text.secondary',
        }}
      >
        {label}
      </Typography>
    </Box>
    <Typography
      component="span"
      sx={{
        fontSize: '14px',
        fontWeight: 600,
        color: 'text.primary',
        textAlign: 'right',
        textTransform: 'capitalize',
      }}
    >
      {value || '--'}
    </Typography>
  </Box>
)

export default InfoRow
